module.exports = __webpack_public_path__ + "media/images/illustrations/Icon-Tutoring-750d5dd215c4b2652bf6e42f3b8c9b01.svg";